/**
 *
 *  have added code for you to retrieve document data. So lets recap. for you to get all client document you will make this call
 * {{url}}/ClientDocuments/{{clientId}}
 * as result you will get an array of docs
 *  {
 *     "clientDocumentId": 57,
 *     "clientId": 1631378,
 *     "categoryCode": "Test",
 *     "fileName": "422453069_10104248753636061_8673412407640130762_n.jpg",
 *     "url": null,
 *     "storageProviderCode": "S3",
 *     "displayName": "Audi A6",
 *     "client": null,
 *     "createdDate": "2024-02-25T21:40:08.0364451+00:00",
 *     "modifiedDate": "2024-02-25T21:40:07.8844034+00:00",
 *     "modifiedBy": 75,
 *     "isDirty": true
 * }
 * you will need to check with
 * @SJ
 *  what categoryCode means what.
 * next, to pull document data/bytes you need to make this call
 * {{v2Url}}/api/Clients/{{clientId}}/documents/v1/57
 * please note that this is implemented in  v2 API so you need to make a call to v2Url. In DEV use this Urk https://biopedapi2.azurewebsites.net. I have added the code for that endpoint to to recognize AM Security token, so you can use exactly the same call as you do today, using the same Auth header, its just URL will be different
 */
import Service from "../Service";

const v1Api = new Service();
const v2Api = new Service(null, null, 'apiPathV2');
export default class DocumentService {
	static async GetClientDocuments(clientId) {
		const docs = await v1Api.request(`ClientDocuments/${clientId}`);
		console.log('Client Docs:', docs);
		return docs;
	}

	static async GetClientDocument(clientId, docId){
		const doc = await v2Api.request(`Clients/${clientId}/documents/v1/${docId}`, {returnType:'blob'});
		console.log('Client Document Download: ', doc);
		return doc;
	}
}



// WEBPACK FOOTER //
// ./src/api/services/DocumentService.js